import {
  ButtonArrowState,
  Modal,
  TertiaryButton,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import React, { useState } from 'react';
import styles from './bankPaymentRedemption.module.scss';

const InfoModal = ({ onClose }) => (
  <Modal
    title={dictionary.bankPayment.labels.infoTitle}
    onClose={onClose}
    className={styles.infoModal}
  >
    <ul className={styles.bulletedList}>
      {dictionary.bankPayment.copy.infoBullets.map((bullet) => (
        <li key={bullet} className={styles.listItem}>
          {bullet}
        </li>
      ))}
    </ul>
    <TertiaryButton
      label={dictionary.closeDialog}
      onClick={onClose}
      arrow={ButtonArrowState.None}
    />
  </Modal>
);

export const BankPaymentInfoDialog = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <button
        className={styles.buttonAsLink}
        type="button"
        onClick={() => setShowModal(true)}
        data-test-id="bank-payment-info-trigger"
      >
        {dictionary.bankPayment.labels.infoTrigger}
      </button>
      {showModal && <InfoModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default BankPaymentInfoDialog;
